import React from "react";
import PropTypes from "prop-types";
import AnimatedNumberComponent from "animated-number-react";
import { roundTo } from "../utils/roundTo";
import { numberWithCommas } from "../utils";

const AnimatedNumber = ({ number, className }) => {
  const format = (value) => `${numberWithCommas(roundTo(value))}`;
  return (
    <AnimatedNumberComponent
      value={number}
      className={className}
      formatValue={format}
      duration={600}
    />
  );
};

export default AnimatedNumber;

AnimatedNumber.propTypes = {
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  format: PropTypes.func,
};
